<template>
    <div class="main">


        <v-row no-gutters class="section-title mb-3" v-if="allOffers.length > 0">
            Daily Quests
        </v-row>


        <v-row no-gutters class="text-14 weight-500 mb-5">{{ currentQuest.instruction }}</v-row>

        <div class="offers-list__container">
            <div v-for="(offer) in allOffers.slice(0,12)" :key="offer.id" class="offer-item" @click="offerTileClicked(offer)">
                <RectangleOfferTile :offer="offer" />
            </div>
        </div>

        <div v-if="!loadingOffers && allOffers.slice(0, 20).length === 0" class="empty-list-subtitle text-h6 mt-1 text-center">
            Sorry, there are no offers available for this quest today!
        </div>


        <div v-if="loadingOffers" class="offers-list__container">
            <v-skeleton-loader :elevation="4" type="list-item-avatar-three-line" v-for="n in 20" :key="n"
                color="rgba(245, 68, 129, 0.1)"></v-skeleton-loader>
        </div>


        <OfferDetailsDialog :offer="selectedOffer" @report-offer="openReportOfferDialog" />

        <ReportOfferDialog />


    </div>
</template>



<script>

import { computed, ref, provide, onMounted } from 'vue';
import { OfferStore } from '@/store/offerStore';

import RectangleOfferTile from '@/components/Tiles/Offer/Rectangle-Offer-Tile.vue';
import OfferDetailsDialog from '../../Offer/StartOfferDialogComponents/Offer-Details-Dialog.vue';
import ReportOfferDialog from '../../Offer/StartOfferDialogComponents/Report-Offer-Dialog.vue';

export default {
    name: 'DailyQuests',
    components: {
        RectangleOfferTile,
        OfferDetailsDialog,
        ReportOfferDialog,
    },
    setup() {
        const offerStore = OfferStore();
        const selectedOffer = ref(null);

        const loadingOffers = ref(true);
        const offerDetailsDialogOpen = ref(false);
        provide('offerDetailsDialogOpen', offerDetailsDialogOpen);

        const reportOfferDialogOpen = ref(false);
        provide('reportOfferDialogOpen', reportOfferDialogOpen);


        const offerTileClicked = (offer) => {
            selectedOffer.value = offer;
            offerDetailsDialogOpen.value = true;
        }

        const openReportOfferDialog = () => {
            offerDetailsDialogOpen.value = false;
            reportOfferDialogOpen.value = true;
        }

        const dailyQuests = [
            {
                instruction: 'Earn over 1000 coins from an offer: ',
                filter: (offer) => offer.coins_amount > 1000 && offer.coins_amount < 3000,
            },
            {
                instruction: 'Earn over 3000 coins from an offer: ',
                filter: (offer) => offer.coins_amount > 3000 && offer.coins_amount < 5000,
            },
            {
                instruction: 'Complete a multi-step offer: ',
                filter: (offer) => offer.steps && offer.steps.length > 1,
            },
            {
                instruction: 'Discover an app: ',
                filter: (offer) => true,
            },
            {
                instruction: 'Complete an offer over 5000 coins: ',
                filter: (offer) => offer.coins_amount > 5000 && offer.coins_amount < 10000,
            },    
            {
                instruction: 'Complete a survey: ',
                filter: (offer) => true,
            },
            {
                instruction: 'Complete an offer over 10000 coins: ',
                filter: (offer) => offer.coins_amount > 10000,
            },
        ];

        const currentDay = new Date().getDay();
        const currentQuest = computed(() => { return dailyQuests[currentDay % dailyQuests.length]; });

        const allOffers = ref([]);

        onMounted(async () => {
            loadingOffers.value = true;

            try {
                if (currentQuest.value.instruction === 'Complete a survey: ') {
                    offerStore.selectCategory(4);
                } else if (currentQuest.value.instruction === "Discover an app: ") {
                    offerStore.selectCategory(2);
                } else {
                    offerStore.selectCategory(undefined);
                }

                // this is already getting called in the store, when the store initializes initially
                // await offerStore.getAllOffers();

                if (currentQuest.value.instruction !== 'Complete a survey: ' &&
                    currentQuest.value.instruction !== 'Discover an app: ') {
                        allOffers.value = offerStore.offers.filter(currentQuest.value.filter);
                } else {
                        allOffers.value = offerStore.offers;
                }
            } finally {
                loadingOffers.value = false;
            }
        });
        


        return {
            selectedOffer,
            offerTileClicked,
            currentQuest,
            allOffers,
            loadingOffers,
            openReportOfferDialog
        }
    }
}
</script>

